var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-card hover-ef",on:{"click":function($event){return _vm.$emit('select', {id: _vm.person.id})}}},[_c('div',{staticClass:"person-card__image"},[_c('img',{attrs:{"src":_vm.person.image,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }